// utils
function getUrlQueries() {
  var queryStr = window.location.search.slice(1);  // 文頭?を除外
  var queries = {};

  // クエリがない場合は空のオブジェクトを返す
  if (!queryStr) return queries;

  // クエリ文字列を & で分割してqueriesに格納
  queryStr.split('&').forEach(function(queryStr) {
    var queryArr = queryStr.split('=');
    queries[queryArr[0]] = queryArr[1];
  });

  return queries;
}